import gql from 'graphql-tag'

export const ProductAndSelectionQuery = gql`
  query ProductAndSelectionQuery($applicationId: ID!) {
    applicationProductSelection(applicationId: $applicationId) {
      id
      applicationId
      productCode
      loanNumber
      amount
      term
      interestRate
      numberOfPayments
      dueDate
      modifiedAt
      stepDownAmt
    }
    productOffers(applicationId: $applicationId) {
      productCode
      channel
      loanNumber
      incrementAmount
      dueDate
      availableDueDates
      minLoan
      maxLoan
      payoffAmount
      qualificationMatrix {
        term
        minLoan
        maxLoan
        interestRate
        numberOfPayments
        fee
      }
    }
  }
`
